/* PÉTALE — line sheet: scale toggle and add-to-cart.
   Each card carries its real Shopify variants in data-variants, so the price,
   edition number and the variant that gets added all follow the chosen scale. */
(function(){
  /* Round 26 (23 Oct, C1-A): one price format everywhere, "$550 CAD" (no cents unless there are any). */
  function money(cents, code){
    var v = (cents / 100);
    var s = v % 1 === 0 ? v.toLocaleString('en-CA') : v.toLocaleString('en-CA', {minimumFractionDigits:2, maximumFractionDigits:2});
    return '$' + s + ' ' + code;
  }

  function card(el){
    var variants;
    try{ variants = JSON.parse(el.getAttribute('data-variants') || '[]'); }catch(e){ return; }
    if(!variants.length) return;

    var code = el.getAttribute('data-currency') || 'CAD';
    var tradePct = parseFloat(el.getAttribute('data-trade-pct') || '0');
    var priceEl = el.querySelector('[data-ls-price]');
    var tradeEl = el.querySelector('[data-ls-trade]');
    var noEl = el.querySelector('[data-ls-no]');
    var addBtn = el.querySelector('[data-ls-add]');
    var btns = [].slice.call(el.querySelectorAll('[data-ls-scale]'));
    var current = variants[0];

    function paint(){
      if(priceEl) priceEl.textContent = money(current.price, code);
      if(noEl && current.sku) noEl.textContent = '№ ' + current.sku;
      if(tradeEl && tradePct > 0){
        tradeEl.textContent = 'Trade ' + money(Math.round(current.price * (1 - tradePct / 100)), code);
      }
      btns.forEach(function(b){
        b.setAttribute('aria-pressed', b.getAttribute('data-ls-scale') === current.title ? 'true' : 'false');
      });
      if(addBtn){
        var out = current.available === false;
        addBtn.disabled = out;
        addBtn.textContent = out ? 'Allocated' : 'Add';
      }
    }

    btns.forEach(function(b){
      b.addEventListener('click', function(){
        var want = b.getAttribute('data-ls-scale');
        for(var i = 0; i < variants.length; i++){
          if(variants[i].title === want){ current = variants[i]; break; }
        }
        paint();
      });
    });

    if(addBtn){
      addBtn.addEventListener('click', function(){
        if(addBtn.hasAttribute('data-busy')) return;
        addBtn.setAttribute('data-busy','');
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {'Content-Type':'application/json', 'Accept':'application/json'},
          body: JSON.stringify({ items: [{ id: current.id, quantity: 1 }] })
        }).then(function(r){
          if(!r.ok) throw new Error('add failed');
          return fetch('/cart.js', {headers:{'Accept':'application/json'}});
        }).then(function(r){ return r.json(); }).then(function(cart){
          addBtn.removeAttribute('data-busy');
          addBtn.setAttribute('data-done','');
          addBtn.textContent = 'Added';
          bumpCart(cart.item_count);
          setTimeout(function(){ addBtn.removeAttribute('data-done'); paint(); }, 1600);
        }).catch(function(){
          addBtn.removeAttribute('data-busy');
          addBtn.textContent = 'Try again';
          setTimeout(paint, 1600);
        });
      });
    }

    paint();
  }

  /* Keep the header's zero-padded count in step without a page reload. */
  function bumpCart(n){
    var span = document.querySelector('.pt-cart__n');
    var link = document.querySelector('.pt-cart');
    if(span){
      span.textContent = (n < 10 ? '0' : '') + n;
      if(n > 0) span.removeAttribute('data-empty'); else span.setAttribute('data-empty','');
    }
    if(link) link.setAttribute('aria-label', 'Cart, ' + n + (n === 1 ? ' specimen' : ' specimens'));
  }

  function boot(){
    document.querySelectorAll('[data-ls-card]').forEach(function(el){
      if(el.hasAttribute('data-ls-init')) return;
      el.setAttribute('data-ls-init','');
      card(el);
    });
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
